import axios from "axios"

import { sessionStorageFactory } from "src/utils/storageUtil"

interface TGeolocation {
  countryCode: string
}

const storedGeolocation = sessionStorageFactory<TGeolocation>({
  key: "minut.geolocation",
})

export async function fetchGeolocationData(): Promise<{
  countryCode: string
}> {
  const storedGeo = storedGeolocation.get()

  if (storedGeo) {
    return storedGeo
  }

  const response = await axios.get<TFetchGeolocationResponse>(
    `https://api.ipgeolocation.io/ipgeo?apiKey=${
      import.meta.env.REACT_APP_IP_GEOLOCATION_API_KEY
    }`,
    { timeout: 4000 }
  )

  const { country_code2: country_code, state_prov: state_prov } = response.data

  /*
   * Canary islands is an autonomus region of Spain, with their own tax rules,
   * hence it has been set up as a separate tax region in Chargebee. IP Geolocation however returns
   * Spain's country code instead of Canary Islands'. So we need to specifically check for Canary Islands
   * in the state_prov and override the country code in that case.
   */
  const countryCode = state_prov?.toLowerCase().includes("canary islands")
    ? "IC"
    : country_code

  const geolocation = {
    countryCode,
  }

  storedGeolocation.set(geolocation)

  return geolocation
}

type TFetchGeolocationResponse = {
  country_code2: string
  state_prov?: string | null
}
